export enum RoutesOffersFullEnum {
  PLANS = 'oferta-plans-full' as any,
  BENEFITS_COMISSIONS = 'oferta-beneficios-comissiones-full' as any,
  CREDITCARD = 'oferta-tarjeta-credito-full' as any,
}
